import { Box, Text, UnorderedList, ListItem } from '@chakra-ui/react';
import Link from 'components/general/Link';
import { useMyProfile } from 'lib/hooks';
import { actualitesPath, ECLAIREURS_PATH } from 'lib/paths';
import ProjetOrientationItem from 'components/general/ProjetOrientationItem';

const etapes = [
  {
    name: 'domaines',
    title:
      'Les domaines dans lesquels j’aimerais faire mes études supérieures.',
    todoText: () => (
      <Box fontSize="sm">
        <Text mt={0}>
          Pour t’aider à trouver les domaines d’études qui t’intéressent, tu
          peux lire :
        </Text>
        <UnorderedList>
          <ListItem>les pistes d’études qui te sont recommandées</ListItem>
          <ListItem>
            2 pistes d’études qui pourraient t’intéresser et les mettre en
            favoris pour les retrouver plus facilement
          </ListItem>
        </UnorderedList>
        <Text>
          et tu peux contacter des étudiants Éclaireurs pour te renseigner sur
          leur profil quand ils étaient au lycée, leur parcours pour intégrer
          leur formation ou encore sur les matières qu’ils étudient dans leur
          formation.
        </Text>
      </Box>
    ),
  },
  {
    name: 'etablissements',
    title:
      'Le type d’établissement dans lequel j’aimerais faire mes études (lycée, école, université).',
    todoText: () => (
      <Box fontSize="sm">
        <Text mt={0}>
          Pour t’aider à trouver le type d’établissement dans lequel tu aimerais
          faire tes études, tu peux lire :
        </Text>

        <UnorderedList>
          <ListItem>les pistes d’études qui te sont recommandées</ListItem>
          <ListItem>
            les articles du blog sur les questions à se poser avant de choisir{' '}
            <Link
              href={actualitesPath(
                '6-questions-a-se-poser-avant-de-choisir-luniversite-apres-le-bac'
              )}
            >
              l’université
            </Link>
            , un{' '}
            <Link
              href={actualitesPath(
                '5-questions-a-se-poser-avant-de-choisir-un-bts-apres-le-bac'
              )}
            >
              BTS
            </Link>{' '}
            ou une{' '}
            <Link
              href={actualitesPath(
                '5-questions-a-se-poser-avant-de-choisir-la-prepa-apres-le-bac'
              )}
            >
              prépa
            </Link>
          </ListItem>
        </UnorderedList>
        <Text>
          et tu peux contacter des étudiants Éclaireurs pour te renseigner sur
          le rythme de travail et leur méthode d’organisation dans leur
          formation.
        </Text>
      </Box>
    ),
  },
  {
    name: 'encadrement',
    title: 'Le type d’encadrement que je préfère (autonome ou très encadré).',
    todoText: () => (
      <Box fontSize="sm">
        <Text mt={0}>
          Pour t’aider à trouver le type d’encadrement que tu préfères, tu peux
          lire :
        </Text>
        <UnorderedList>
          <ListItem>les pistes d’études qui te sont recommandées</ListItem>
          <ListItem>
            les articles du blog sur les questions à se poser avant de choisir{' '}
            <Link
              href={actualitesPath(
                '6-questions-a-se-poser-avant-de-choisir-luniversite-apres-le-bac'
              )}
            >
              l’université
            </Link>
            , un{' '}
            <Link
              href={actualitesPath(
                '5-questions-a-se-poser-avant-de-choisir-un-bts-apres-le-bac'
              )}
            >
              BTS
            </Link>{' '}
            ou une{' '}
            <Link
              href={actualitesPath(
                '5-questions-a-se-poser-avant-de-choisir-la-prepa-apres-le-bac'
              )}
            >
              prépa
            </Link>
          </ListItem>
          <ListItem>
            le{' '}
            <Link href={'les-formations-post-bac-en-france-guide-pratique'}>
              guide pratique
            </Link>{' '}
            des formations post-bac en France
          </ListItem>
        </UnorderedList>
        <Text>
          et tu peux contacter des étudiants Éclaireurs pour te renseigner sur
          le niveau d’encadrement de leur formation.
        </Text>
      </Box>
    ),
  },
  {
    name: 'admission',
    title: 'Les critères d’admission des formations qui m’intéressent.',
    todoText: () => (
      <Box fontSize="sm">
        <Text mt={0}>
          Pour t’aider à trouver les critères d’admission des formations qui
          t’intéressent, tu peux lire :
        </Text>
        <UnorderedList>
          <ListItem>
            les pistes d’études qui t’intéressent, tu y trouveras des réponses !
          </ListItem>
          <ListItem>
            le blog avec des articles sur les formations qui t'intéressent !
          </ListItem>
        </UnorderedList>
        <Text fontStyle="italic">
          Astuce : Lorsque tu es sur la page{' '}
          <Link href={ECLAIREURS_PATH}>“Tous les Éclaireurs”</Link> tu peux
          utiliser le filtre “Type de formation” et contacter des étudiants
          Éclaireurs pour te renseigner sur les critères d’admission dans leur
          formation.
        </Text>
      </Box>
    ),
  },
  {
    name: 'localisation',
    title: 'La ville, la région, le pays où j’aimerais faire mes études.',
    todoText: () => (
      <Box fontSize="sm">
        <Text mt={0}>
          Pour t’aider à réfléchir à la ville, la région ou le pays où tu
          aimerais faire tes études, tu peux contacter des étudiants Éclaireurs
          pour te renseigner sur leur expérience de la vie étudiante !
        </Text>
        <Text fontStyle="italic">
          Astuce : Lorsque tu es sur la page “Tous les Éclaireurs” tu peux
          utiliser le filtre “expériences à partager” et contacter les étudiants
          Éclaireurs qui ont quitté leur domicile familial pour leurs études.
        </Text>
      </Box>
    ),
  },
  {
    name: 'logement',
    title:
      'Le logement dans lequel je souhaiterais être (chez mes parents, en studio, etc.).',
    todoText: () => (
      <Box fontSize="sm">
        <Text mt={0}>
          Pour t’accompagner dans ta recherche de logement et ton installation,
          tu peux lire :
        </Text>
        <UnorderedList>
          <ListItem>
            l’article du blog{' '}
            <Link
              href={actualitesPath('les-logements-etudiants-comment-ca-marche')}
            >
              “Les logements étudiants : comment ça marche ?”
            </Link>
          </ListItem>

          <ListItem>
            l’article du blog{' '}
            <Link
              href={actualitesPath(
                'le-budget-etudiant-gerer-financierement-sa-vie-etudiante'
              )}
            >
              “budget étudiant : gérer financièrement sa vie étudiante”
            </Link>
          </ListItem>

          <ListItem>
            l’article du blog{' '}
            <Link href={actualitesPath('domicile-familial-etudes')}>
              “Quitter le domicile parental pour ses études”
            </Link>
          </ListItem>
        </UnorderedList>
        <Text>
          et tu peux contacter des étudiants Éclaireurs pour te renseigner sur
          le type de logement dans lequel ils vivent.
        </Text>
        <Text fontStyle="italic">
          Astuce : Lorsque tu es sur la page{' '}
          <Link href={ECLAIREURS_PATH}>“Tous les Éclaireurs”</Link> tu peux
          utiliser le filtre “expériences à partager” et contacter les étudiants
          Éclaireurs qui ont quitté leur domicile familial.
        </Text>
      </Box>
    ),
  },
  {
    name: 'couts',
    title: 'Les coûts des études que j’envisage.',
    todoText: () => (
      <Box fontSize="sm">
        <Text mt={0}>
          Pour t’aider à trouver les coûts des études que tu envisages, tu peux
          lire :
        </Text>
        <UnorderedList>
          <ListItem>
            L’article du blog{' '}
            <Link
              href={'le-budget-etudiant-gerer-financierement-sa-vie-etudiante'}
            >
              “budget étudiant : gérer financièrement sa vie étudiante”
            </Link>
          </ListItem>
        </UnorderedList>
        <Text>
          et tu peux contacter des étudiants Éclaireurs pour te renseigner sur
          le coût de leur formation et leur budget étudiant.
        </Text>
      </Box>
    ),
  },
  {
    name: 'aides',
    title: 'Les aides auxquelles je peux prétendre.',
    todoText: () => (
      <Box fontSize="sm">
        <Text mt={0}>
          Pour t’aider à trouver les aides auxquelles tu peux prétendre, ou
          simplement pour te renseigner sur les aides qui existent, tu peux lire
          :
        </Text>
        <UnorderedList>
          <ListItem>
            L’article du blog{' '}
            <Link
              href={actualitesPath(
                'le-budget-etudiant-gerer-financierement-sa-vie-etudiante'
              )}
            >
              “budget étudiant : gérer financièrement sa vie étudiante”
            </Link>
          </ListItem>
        </UnorderedList>
        <Text fontStyle="italic">
          Astuce : Lorsque tu es sur la page{' '}
          <Link href={ECLAIREURS_PATH}>“Tous les Éclaireurs”</Link> tu peux
          utiliser le filtre “expériences à partager” et contacter les étudiants
          pour te renseigner sur les aides dont ils bénéficient.
        </Text>
      </Box>
    ),
  },
];

const ProjetOrientation = () => {
  const { myProfile } = useMyProfile();
  const prochainesEtapes = myProfile?.prochainesEtapes || [];
  return (
    <Box>
      {etapes.map((e, i) => (
        <ProjetOrientationItem item={e} key={i} etapes={prochainesEtapes} />
      ))}
    </Box>
  );
};

export default ProjetOrientation;
